import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getFormattedDate,changeDateFormat,isEndDateGreater,formatDateWithFourDigitYear} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import titlesData from '../../../../titles.json';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {urbanCurrentPriceReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';


function UrbanCurrentPriceReport() {

  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const [isDivision, setIsDivision] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const storedLanguage = localStorage.getItem('language');
  const today = new Date();
  const config = getAuthHeaders();





//handle excel sheet ***************
const handleGenerateExcel = () => {
  if (!startDate || !endDate) {
    toast.error('Please select the date range', messages.COLOR_RED);
    return;
  }

  if(!isEndDateGreater(startDate,endDate)){
    toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
    return;
  }

   showLoading(true);
   let sDate= getFormattedDate(startDate)
   let eDate= getFormattedDate(endDate)
  const payload = {
      fromDate: sDate,
      toDate: eDate,
  };

// POST request to API
axios
    .post(`${API_URL}api/price/getUrbanConsumerRetailPrice`, payload, config)
    .then((response) => {
        let allData=response.data;
        if(allData.status){
            downloadReport(allData.data[0].GroupCodes,sDate,eDate)
        }else{
             toast.error('Data is not Found', messages.COLOR_RED);
       }
       
        showLoading(false);
    })
    .catch((error) => {
        console.error('API Error:', error);
     }).finally(()=>{
      showLoading(false);
    });
}




const formatGrossValue = (value) => {
    if (value === 0) return '0.00';
    if (value === "NaN") return '';
    if (value === '' || value === null || value === 'null' || value === undefined) return '0.00';
    const n = Number(value);
    if (!Number.isFinite(n)) return '0.00';
    return n.toFixed(2);
};




// Dwonload Report **************
const downloadReport=(allData,sDate,eDate)=>{

    const transformedData = allData.map(item => [
       
        item.DISTRICT_CODE,
        formatDateWithFourDigitYear(item.mondate),
        item.DISTRICT_UNIT,
        formatGrossValue(item.CURRENT_PRICE_WHEAT_FLOUR),
        formatGrossValue(item.CURRENT_PRICE_RICE_ARWA),
        formatGrossValue(item.CURRENT_PRICE_GRAM_WHOLE),
        formatGrossValue(item.CURRENT_PRICE_MAIZE),
        formatGrossValue(item.CURRENT_PRICE_ARHAR_DAL),
        formatGrossValue(item.CURRENT_PRICE_URD_DAL),
        formatGrossValue(item.CURRENT_PRICE_MASUR_DAL),
        formatGrossValue(item.CURRENT_PRICE_PEA_DAL),
        formatGrossValue(item.CURRENT_PRICE_MOONG_DAL),
        formatGrossValue(item.CURRENT_PRICE_GRAM__DAL),
        formatGrossValue(item.CURRENT_PRICE_SOYABEENBARI),
        formatGrossValue(item.CURRENT_PRICE_MILK),
        formatGrossValue(item.CURRENT_PRICE_GHEE),
        formatGrossValue(item.CURRENT_PRICE_MUSTARD_OIL),
        formatGrossValue(item.CURRENT_PRICE_VANASPATI_GHEE),
        formatGrossValue(item.CURRENT_PRICE_GOAT_MEAT),
        formatGrossValue(item.CURRENT_PRICE_FISH_ROHU),
        formatGrossValue(item.CURRENT_PRICE_EGGS),
        formatGrossValue(item.CURRENT_PRICE_POTATO),
        formatGrossValue(item.CURRENT_PRICE_TOMATO),
        formatGrossValue(item.CURRENT_PRICE_ONION),
        formatGrossValue(item.CURRENT_PRICE_BRINJAL),
        formatGrossValue(item.CURRENT_PRICE_CHILLI),
        formatGrossValue(item.CURRENT_PRICE_APPLE),
        formatGrossValue(item.CURRENT_PRICE_BANANA),
        formatGrossValue(item.CURRENT_PRICE_MANGO),
        formatGrossValue(item.CURRENT_PRICE_GROUNDNUT),
        formatGrossValue(item.CURRENT_PRICE_DRY_FRUIT_COCONUT_COPRA),
        formatGrossValue(item.CURRENT_PRICE_SUGAR),
        formatGrossValue(item.CURRENT_PRICE_GUR),
        formatGrossValue(item.CURRENT_PRICE_CORRIANDER_WHOLE),
        formatGrossValue(item.CURRENT_PRICE_DRY_CHILLIES_WHOLE),
        formatGrossValue(item.CURRENT_PRICE_TURMERIC_WHOLE),
        formatGrossValue(item.CURRENT_PRICE_SALT_POWDER),
        formatGrossValue(item.CURRENT_PRICE_GARAM_MASALA),
        formatGrossValue(item.CURRENT_PRICE_PREPARED_SWEETS),
        formatGrossValue(item.CURRENT_PRICE_BISCUITS),
        formatGrossValue(item.CURRENT_PRICE_SEV_BESAN),
        formatGrossValue(item.CURRENT_PRICE_TEA_LEAF),
        formatGrossValue(item.CURRENT_PRICE_TEA_CUPS),
        formatGrossValue(item.CURRENT_PRICE_COLD_DRINK),
        formatGrossValue(item.CURRENT_PRICE_AVERAGE_OF_PAN_LEAF_SADA_AND__SUPARI),
        formatGrossValue(item.CURRENT_PRICE_BIDI),
        formatGrossValue(item.CURRENT_PRICE_CIGRATTE),
        formatGrossValue(item.CURRENT_PRICE_TOBACO_CHEWING_LEAF),
        formatGrossValue(item.CURRENT_PRICE_COUNTRY_LIQUOR),
        formatGrossValue(item.CURRENT_PRICE_ELECTRICITY),
        formatGrossValue(item.CURRENT_PRICE_LPG),
        formatGrossValue(item.CURRENT_PRICE_FIREWOODS),
        formatGrossValue(item.CURRENT_PRICE_KEROSENE),
        formatGrossValue(item.CURRENT_PRICE_MATCH_BOX),
        formatGrossValue(item.CURRENT_PRICE_CANDLE),
        formatGrossValue(item.CURRENT_PRICE_HOUSE_RENT),
        formatGrossValue(item.CURRENT_PRICE_AVERAGE_OF_RAJ_AND_UNSKILLED_LABOUR),
        formatGrossValue(item['CURRENT_PRICE_WATER_CHARGES/TAX']),
        formatGrossValue(item.CURRENT_PRICE_CLOTH_SHIRT),
        formatGrossValue(item.CURRENT_PRICE_SARI),
        formatGrossValue(item.CURRENT_PRICE_DHOTI_MARDANI),
        formatGrossValue(item.CURRENT_PRICE_HOSIERY_BANIYAN),
        formatGrossValue(item.CURRENT_PRICE_BEDSHEET),
        formatGrossValue(item.CURRENT_PRICE_LEATHER_SHOES),
        // API null must stay null for formatting (?? would skip null and read wrong legacy key → NaN).
        formatGrossValue(
          Object.prototype.hasOwnProperty.call(item, 'CURRENT_PRICE_LEATHER_SANDALS_(LADIES)')
            ? item['CURRENT_PRICE_LEATHER_SANDALS_(LADIES)']
            : item.CURRENT_PRICE_LEATHER_SANDALSLADIES
        ),
        formatGrossValue(item.CURRENT_PRICE_RUBBER_PVC_FOOTWEAR_CHAPPAL),
        formatGrossValue(item.CURRENT_PRICE_TUTIONFEES),
        formatGrossValue(item.CURRENT_PRICE_REGISTER),
        formatGrossValue(item.CURRENT_PRICE_NEWSPAPERS_HINDI_DAINIK),
        formatGrossValue(item.CURRENT_PRICE_CROCIN),
        formatGrossValue(item.CURRENT_PRICE_ATIN_50),
        formatGrossValue(item.CURRENT_PRICE_DAYNIL),
        formatGrossValue(item.CURRENT_PRICE_BENADRYL_COUGH_SYRUP114ML),
        formatGrossValue(item.CURRENT_PRICE_DOCTORS_FEE_AT_CLINIC),
        formatGrossValue(item.CURRENT_PRICE_BLOOD_TEST),
        formatGrossValue(item.CURRENT_PRICE_CINEMA_TICKET),
        formatGrossValue(item.CURRENT_PRICE_CABEL_TV_RENT),
        formatGrossValue(item.CURRENT_PRICE_COLOUR_TV),
        formatGrossValue(item.CURRENT_PRICE_BATHING_SOAP),
        formatGrossValue(item.CURRENT_PRICE_HAIR_OIL),
        formatGrossValue(item.CURRENT_PRICE_TOOTHPASTE),
        formatGrossValue(item.CURRENT_PRICE_TELCOM_POWDER),
        formatGrossValue(item.CURRENT_PRICE_SHAVING_BLADES),
        formatGrossValue(item.CURRENT_PRICE_TORCH),
        formatGrossValue(item.CURRENT_PRICE_AGARBATI),
        formatGrossValue(item.CURRENT_PRICE_ELECTRIC_BULB),
        formatGrossValue(item.CURRENT_PRICE_TAILOR),
        formatGrossValue(item.CURRENT_PRICE_BARBER),
        formatGrossValue(item.CURRENT_PRICE_GRINDING),
        formatGrossValue(item.CURRENT_PRICE_WASHING_SHOP),
        formatGrossValue(item.CURRENT_PRICE_SINGLE_BED),
        formatGrossValue(item.CURRENT_PRICE_THALI),
        formatGrossValue(item.CURRENT_PRICE_CEILLING_FAN),
        formatGrossValue(item.CURRENT_PRICE_UNSKILLED_LABOUR),
        formatGrossValue(item.CURRENT_PRICE_MOBILE_PHONE_HANDSET),
        formatGrossValue(item.CURRENT_PRICE_TELEPHONE_CHARGES),
        formatGrossValue(item.CURRENT_PRICE_REGISTERD_LETTER_10_GMS),
        formatGrossValue(item.CURRENT_PRICE_PETROL),
        formatGrossValue(item.CURRENT_PRICE_RAILWAY_FARE),
        formatGrossValue(item.CURRENT_PRICE_BUS_FARE),
        formatGrossValue(item.CURRENT_PRICE_CAR),
        formatGrossValue(item.CURRENT_PRICE_MOTOR_CYCLE),
        formatGrossValue(item.CURRENT_PRICE_GOLD),
        formatGrossValue(item.CURRENT_PRICE_SILVER)         

]);



    const excelObjectData = {
      fileName:"PRICurrentPriceUrban",
      fileType:'xls',
      sheetName: 'PRICurrentPrice',
      firstRowMergeCells: "A1:CZ1",
      firstRowExportDate:  changeDateFormat(new Date()),
      secondRowMergeCells: "A2:CZ2",
      secondRowText: `                                                                                                 Urban Current Price(${sDate}-${eDate}) (Base Year 2011-12=100)`,
      headerEnglishColumns: [
           'Reg_Dist',
            'Month',
            ' District Unit',
            'गेहूँ आटा',
            'चावल - अरवा',
            'चना साबुत',
            'मक्का ',
            'अरहर दाल',
            'उड़द दाल ',
            'मसूर दाल',
            'मटर दाल',
            'मूंग दाल',
            'चना दाल',
            'सोयाबीन बरी ',
            'दूध तरल ',
            'घी',
            'सरसों का तेल',
            'वनस्पति घी',
            'मांस बकरे का',
            'मछली रोहू',
            'अण्डा ',
            'आलू',
            'टमाटर',
            'प्याज',
            'बैंगन',
            'मिर्च',
            'सेब',
            'केला',
            'आम',
            'मूंगफली',
            'नारियल (कोपरा)',
            'चीनी',
            'गुड़',
            'धनिया (साबुत)',
            'मिर्च (साबुत)',
            'हल्दी',
            'नमक पिसा',
            'गरम मसाला',
            'तैयार मिठाई',
            'बिस्कुट',
            'नमकीन',
            'चाय पत्ती',
            'चायकप',
            'शीतल पेय',
            'पान व सुपारी का सामान्य औसत',
            'बीड़ी',
            'सिगरेट',
            'तम्बाकू पत्ती',
            'शराब ',
            'बिजली',
            'एल० पी० जी० गैस ',
            'जलाऊ लकड़ी  ',
            'मिटटी का तेल',
            'माचिस',
            'मोमबत्त्ती',
            'आवास किराया',
            'राज व अकुशल श्रमिक की मजदूरी का औसत',
            'जल भार',
            'कमीज का कपड़ा ',
            'साड़ी',
            'धोती मर्दानी',
            'बनियान',
            'बेडशीट',
            'चमड़े के जूते',
            'चमड़े के सैंडिल (लेडीज)',
            'रबड़ / पी० वी० सी० के चप्पल',
            'ट्यूशन फीस/कोचिंग फीस',
            'रजिस्टर',
            'समाचार पत्र ',
            'क्रोसीन ',
            'एटीन 50 ',
            'डायनील',
            'कफसीरप - बेनाड्रिल',
            'डॉक्टर फीस क्लीनिक पर',
            'ब्लड टेस्ट फीस',
            'सिनेमा टिकट',
            'केबिल टी० वी० किराया',
            'रंगीन टी० वी०',
            'नहाने का साबुन',
            'केश तेल',
            'टूथ  पेस्ट',
            'टेलकम पाउडर',
            'सेविंग ब्लेड',
            'टार्च पीतल की',
            'अगरबत्ती',
            'बिजली का बल्ब',
            'दर्जी की सिलाई',
            'नाई',
            'पिसाई',
            'धुलाई का साबुन',
            'सिंगल बेड',
            'थाली',
            'सीलिंग फैन',
            'अकुशल मजदूर',
            'मोबाइल फ़ोन/हैंडसेट',
            'टेलीफ़ोन कॉल दरे (बी० एस० एन० एल०) ',
            'रजिस्टर्ड पत्र',
            'पेट्रोल',
            'रेल यात्रा किराया',
            'बस यात्रा किराया',
            'कार',
            'मोटर साइकिल',
            'स्वर्ण आभूषण',
            'चांदी का आभूषण'



         ],
         excelRowData:transformedData

    };

    excelObjectData.excelRowData = transformedData;
    urbanCurrentPriceReport(excelObjectData);

}




  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row">
                    <div className="col-12">
                        <h4 className="page_heading">
                            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.CURRENT_PRICE_REPORT : priceTitle.en.CURRENT_PRICE_REPORT }} />
                        </h4>
                    </div>
                </div>
                <div className="row align-items-end">
                    {isDivision && (
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                            <label className="form-label">{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                            <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                        </div>
                    )}

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                        <label className="form-label">From Date</label>
                        <DatePicker
                            className="form-control calendar_icon"
                            wrapperClassName="w-100 d-block"
                            selected={startDate}
                            onChange={(e) => { setStartDate(e) }}
                            dateFormat="MMM yyyy"
                            showMonthYearPicker
                            placeholderText="Select month"
                            maxDate={today}
                        />
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                        <label className="form-label">To Date</label>
                        <DatePicker
                            className="form-control calendar_icon"
                            wrapperClassName="w-100 d-block"
                            selected={endDate}
                            onChange={(e) => { setEndDate(e) }}
                            dateFormat="MMM yyyy"
                            showMonthYearPicker
                            placeholderText="Select month"
                            maxDate={today}
                        />
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                        <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default UrbanCurrentPriceReport